export enum UILanguage {
    NotSet = 0,
    USEnglish = 1,
    Spanish = 2,
    Russian = 3
}